export const TRANSLATE = {
  SWITCH_LANGUAGE: "switchLanguage",
  REQURED_USERNAME: "pleaseEnterUsername",
  REQURED_PASSWORD: "pleaseEnterPassword",
  LOGIN: "login",
  REGISTER: "register",
  CONFIRM_PASSWORD: "pleaseConfirmPassword",
  REGISTER_SUCCESS: "registerSuccessText",
  WRONG_CREDENTIAL: "wrongCredential",
  LOGIN_SUCCESS: "loginSuccessText",
  HOME: "home",
  RECHARGE: "recharge",
  TREND: "trend",
  PROFILE: "profile",
  PROMOTION: "promotion",
  PRODUCT_DETAIL: "productDetail",
  ONLINE_SERVICE: "onlineService",
  PRODUCT_DETAIL_CONTENT: "productDetailContent",
  PRODUCT_DETAIL_CONTENT1: "productDetailContent1",
  PRODUCT_DETAIL_CONTENT2: "productDetailContent2",
  PRODUCT_DETAIL_CONTENT3: "productDetailContent3",
  RECHARGE_OFFLINE: "rechargeOffline",
  BANK_TO_PAY: "bankToPay",
  RECHARGE_ONLINE_BANK: "rechargeOnlineBank",
  CONFIRM: "confirm",
  CANCEL: "cancel",
  REQUIRED_RECHARGE_AMOUNT: "pleaseEnterRechargeAmount",
  FUND_DETAIL: "fundDetail",
  INVESTMENT_RECORD: "investmentRecord",
  SECURIRY_CENTER: "securityCenter",
  CUSTOMER_SERVICE: "customerService",
  SETTING: "setting",
  WITHDRAW: "withdraw",
  BALANCE: "balance",
  TODAY_PROFIT: "todayProfit",
  LOGIN_PASSWORD: "loginPassword",
  WITHDRAW_PASSWORD: "withdrawPassword",
  ADD_BANK_ACCOUNT: "connectBankAccount",
  BANK_NAME: "bankName",
  ACCOUNT_NO: "accountNo",
  ACCOUNT_NAME: "accountName",
  OLD_PASSWORD: "oldPassword",
  NEW_PASSWORD: "newPassword",
  CONFIRM_NEW_PASSWORD: "confirmNewPassword",
  SUCCESS: "success",
  PLEASE_CONFIRM_PASSWORD: "pleaseConfirmPassword",
  PLEASE_OLD_PASSWORD: "pleaseenterOldPassword",
  PLEASE_NEW_PASSWORD: "pleaseenterNewPassword",
  OLD_PASSWORD_INCORRECT: "oldPasswordIncorrect",
  PASSWORD_NOT_MATCH: "passwordNotMatch",
  UPDATE_LOGIN_PASSWORD: "updateLoginPassword",
  UPDATE_WITHDRAW_PASSWORD: "updateWithdrawPassword",
  WITHDRAW_AMOUNT: "withdrawAmount",
  SOMETHING_WENT_WRONG: "somethingWentWrong",
  INSUFFICIENT: "insufficientBalance",
  USER_NOT_SET_WITHDRAW_PASSWORD: "userNotSetWithdrawPassword",
  REQUIRED_WITHDRAW_AMOUNT: "pleaseEnterWithdrawAmount",
  REMAINING_BALANCE: "remainingBalance",
  UNTIL: "until",
  ROUNDS: "rounds",
  TRADE_CATEGORY: "tradeCategory",
  SINGLE_ROUND: "singleRound",
  OPERATION: "operation",
  USER: "user",
  BUY: "buy",
  NAME: "name",
  LASTNAME: "lastname",
  CRYPTO_ADDRESS: "cryptoAddress",
  NETWORK: "network",
  ACCOUNT_TYPE: "accountType",
  CRYPTO: "crypto",
  BANK: "bank",
  LOGOUT: "logout",
  SETTING_LANGUAGE: "settingLanguage",
  INVEST_AMOUNT: "investAmount",
  PROFIT_AMOUNT: "profitAmount",
  TRANSACTION_TYPE: "transactionType",
  TIME: "time",
  INVEST_SUCCESS: "investSuccess",
  INVEST_FAILED: "investFail",
  STATUS: "status",
  HISTORY: "history",
  EVENT_DETAIL: "eventDetail",
  PERSONAL_LOAN: "personalLoan",
  HOT_PRODUCT: "hotProduct",
  MARKET_TREND: "marketTrend",
  DEPOSIT: "deposit",
  ENTER_AMOUNT: "enterAmount",
  DELETE_CONFIRM: "deleteConfirm",
  DEPOSIT_LIST: "depositList",
  DEPOSIT_DATE: "depositDate",
  PROFIT: "profit",
  AMOUNT: "amount",
  MAX_AMOUNT: "maxAmount",
  REQUIRED_OPTIONS: "pleaseSelectOptions",
  ENTER_BUY_AMOUNT: "pleaseEnterBuyAmount",
  ENTER_ACCOUNT_NAME: "pleaseEnterAccountName",
  ENTER_BANK_NAME: "pleaseEnterBankName",
  ENTER_ACCOUNT_NO: "pleaseEnterAccountNo",
  USERNAME_MUST_BE_ENGLISH: "usernameMustBeEnglish",
};
